import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import IconRobotPencil from './assets/robot-pencil.svg';

export class AIAssistantUI extends Plugin {
  init() {
    const editor = this.editor;
    editor.ui.componentFactory.add('aiAssistant', () => {
      const button = new ButtonView();
      button.set({
        label: 'AI Assistant',
        icon: IconRobotPencil, // Use the icon from the assets
        tooltip: true
      });
      // Add functionality to the button here
      button.on('execute', this._click.bind(this));
      return button;
    });
  }

  _click() {
    const aiassistantEvent = new window.Event('aiassistant-event');
    window.dispatchEvent(aiassistantEvent);
  }
}
